/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Comparison from './Comparison.vue'
import AppHeaderWithMenu from '../../components/layout/AppHeaderWithMenu'
// import AppSidebar from '../../components/layout/AppSidebar'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/comparison/:raceId',
      name: 'comparison',
      components: {
        default: Comparison,
        header: AppHeaderWithMenu,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
